import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { GuestGuard } from './guard/guest.guard';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full',
	},
	{
		path: 'auth',
		redirectTo: 'auth/home',
		pathMatch: 'full',
	},
	{
		path: 'home',
		canActivate: [GuestGuard],
		loadChildren: () =>
			import('./page/guest/home/home.module').then(
				(m) => m.HomePageModule
			),
	},
	{
		path: 'login',
		canActivate: [GuestGuard],
		loadChildren: () =>
			import('./page/guest/login/login.module').then(
				(m) => m.LoginPageModule
			),
	},
	{
		path: 'password',
		loadChildren: () =>
			import('./page/guest/password/password.module').then(
				(m) => m.PasswordPageModule
			)
	},
	{
		path: 'reset',
		loadChildren: () =>
			import('./page/guest/reset/reset.module').then(
				m => m.ResetPageModule
			)
	},
	{
		path: 'verify',
		loadChildren: () =>
			import('./page/guest/verify/verify.module').then(
				m => m.VerifyPageModule
			)
	},
	{
		path: 'signup',
		loadChildren: () =>
			import('./page/guest/signup/signup.module').then(
				(m) => m.SignupPageModule
			),
	},
	{
		path: 'auth',
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('./page/auth/auth.module').then(
				(m) => m.AuthPageModule
			)
	},
	{
		path: 'verify',
		loadChildren: () => import('./page/guest/verify/verify.module').then(m => m.VerifyPageModule)
	},
	{
		path: 'delete',
		loadChildren: () => import('./page/auth/account/delete/delete.module').then(m => m.DeletePageModule)
	},
	{
		path: 'consumable',
		loadChildren: () => import('./modal/consumable/consumable.module').then(m => m.ConsumablePageModule)
	},
	{
		path: 'custom-form',
		loadChildren: () => import('./modal/custom-form/custom-form.module').then(m => m.CustomFormPageModule)
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule { }
